<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" scrollable persistent max-width=550 content-class="round-2xl")
  v-card
    v-card-text.px-6.pt-6
      .text-lg.font-medium.neutral700--text {{ tier.name }}
      .text-sm.neutral700--text {{ tier.description }}
      .text-sm.font-medium.neutral700--text.mt-4 {{ tier.panels.length === 0 ? 'No panel included' : 'Panel' }}
      v-row.mt-2(no-gutters)
        template(v-for="panel in tier.panels")
          v-col.px-3(cols="6")
            div.d-flex.align-center
              v-avatar.mr-3(color="neutral700" size="7")
              .text-sm.neutral700--text {{ panel.name }}
      .text-sm.font-medium.neutral700--text.mt-4 {{ tier.self_pay.length === 0 ? 'No pay method included' : 'Self pay' }} Self pay
      v-row.mt-2(no-gutters)
        template(v-for="selfpay in tier.self_pay")
          v-col.px-3(cols="6")
            div.d-flex.align-center
              v-avatar.mr-3(color="neutral700" size="7")
              .text-sm.neutral700--text {{ selfpay.name }}
    v-divider
    v-card-actions.px-6
      v-spacer
      y-button(label="Close" size="sm" color="neutral700" text-color="neutral100" @click="closeDialog")
</template>

<script>

export default {
  name: 'DeleteConfirmationDialog',
  props: {
    open: {
      type: Boolean,
    },
    tier: {
      type: Object
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closed')
      this.showDialog = false
    }
  },
}
</script>